const GTM_ACCOUNTS = [
  {
    "name": "Monetary Authority of Singapore (MAS)",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Regulator",
    "owner": "Ajay",
    "notes": "Central bank/regulator. Key relationship for regulatory credibility.",
    "id": "acc_0001",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "DBS",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Largest bank in SEA. Strong digital banking leadership.",
    "id": "acc_0002",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "OCBC",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Major SG bank. Gilbert ex-CRO connection.",
    "id": "acc_0003",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "UOB",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Major SG bank with strong ASEAN network.",
    "id": "acc_0004",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Standard Chartered SG",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Global bank with SG as key hub.",
    "id": "acc_0005",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "HSBC SG",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Global bank — major AML/compliance budget.",
    "id": "acc_0006",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Citi SG",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "US bank APAC hub.",
    "id": "acc_0007",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Bank of Singapore",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Private banking arm of OCBC.",
    "id": "acc_0008",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Maybank SG",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Malaysian bank SG operations. Gilbert ex-Maybank CRO.",
    "id": "acc_0009",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "RHB SG",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Malaysian bank SG operations.",
    "id": "acc_0010",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "BNP Paribas SG",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "French bank APAC hub.",
    "id": "acc_0011",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Singtel",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Largest telco in SG. Digital infrastructure leader.",
    "id": "acc_0012",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "StarHub",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Major SG telco.",
    "id": "acc_0013",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "M1",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Keppel-owned telco.",
    "id": "acc_0014",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Simba/TPG",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "SIMBA Telecom — newer entrant.",
    "id": "acc_0015",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "NCS",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Singtel subsidiary — IT services.",
    "id": "acc_0016",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "ST Engineering",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "GovTech-adjacent. Defense + digital.",
    "id": "acc_0017",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "NetLink Trust",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Fibre network infrastructure.",
    "id": "acc_0018",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Keppel DC REIT",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Data center REIT.",
    "id": "acc_0019",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Digital Realty SG",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Global DC provider SG ops.",
    "id": "acc_0020",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Equinix SG",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Global DC provider SG ops.",
    "id": "acc_0021",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Micron SG",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Major semiconductor fab.",
    "id": "acc_0022",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "GlobalFoundries SG",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Semiconductor manufacturing.",
    "id": "acc_0023",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "ASMPT SG",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Semiconductor equipment.",
    "id": "acc_0024",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Infineon SG",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Power semiconductor manufacturing.",
    "id": "acc_0025",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Seagate SG",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "HDD/storage manufacturing.",
    "id": "acc_0026",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Rolls-Royce SG",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Aerospace manufacturing hub.",
    "id": "acc_0027",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Sembcorp Marine/Seatrium",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Marine & offshore engineering.",
    "id": "acc_0028",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "ExxonMobil Chemicals SG",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Petrochemical complex.",
    "id": "acc_0029",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Shell Energy & Chemicals Park",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Integrated refinery + chemicals.",
    "id": "acc_0030",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "GovTech",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Government Technology Agency — key digital transformation body.",
    "id": "acc_0031",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "IMDA",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Infocomm Media Development Authority.",
    "id": "acc_0032",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "MCI",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Ministry of Communications and Information.",
    "id": "acc_0033",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "MOF Singapore",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Ministry of Finance.",
    "id": "acc_0034",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "MHA Singapore",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Ministry of Home Affairs.",
    "id": "acc_0035",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "MINDEF/DSTA",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Defence Science & Technology Agency.",
    "id": "acc_0036",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "MOH Singapore",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Ministry of Health.",
    "id": "acc_0037",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "LTA",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Land Transport Authority.",
    "id": "acc_0038",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "PSA",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Port of Singapore Authority — global port operator.",
    "id": "acc_0039",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "EDB",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Economic Development Board.",
    "id": "acc_0040",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Temasek",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Sovereign investment company. Major influence.",
    "id": "acc_0041",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "GIC",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Sovereign wealth fund.",
    "id": "acc_0042",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Keppel",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Infrastructure + data centers.",
    "id": "acc_0043",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Sembcorp",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Energy + urban development.",
    "id": "acc_0044",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Jardine Matheson",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Regional conglomerate.",
    "id": "acc_0045",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Wilmar",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Agribusiness — ESG supply chain relevance.",
    "id": "acc_0046",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Olam Group",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Global food & agri business. ESG supply chain.",
    "id": "acc_0047",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "RGE (Royal Golden Eagle)",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Resources-based manufacturing group. ESG relevance.",
    "id": "acc_0048",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Singapore Airlines Group",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "National carrier + supply chain.",
    "id": "acc_0049",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "CapitaLand",
    "country": "Singapore",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Real estate & fund management.",
    "id": "acc_0050",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Bank Negara Malaysia",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Regulator",
    "owner": "Ajay",
    "notes": "Central bank of Malaysia.",
    "id": "acc_0051",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Maybank",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Largest bank in Malaysia. Gilbert ex-CRO.",
    "id": "acc_0052",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "CIMB",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Major ASEAN universal bank.",
    "id": "acc_0053",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Public Bank",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Largest non-government bank.",
    "id": "acc_0054",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "RHB",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Universal bank.",
    "id": "acc_0055",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Hong Leong Bank",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Part of Hong Leong Group.",
    "id": "acc_0056",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "AmBank",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Universal bank.",
    "id": "acc_0057",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Bank Rakyat",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Cooperative bank.",
    "id": "acc_0058",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Bank Islam",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Islamic banking leader.",
    "id": "acc_0059",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Affin Bank",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "",
    "id": "acc_0060",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Alliance Bank",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "",
    "id": "acc_0061",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Maxis",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Major telco.",
    "id": "acc_0062",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "CelcomDigi",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Merged entity — largest mobile operator.",
    "id": "acc_0063",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Telekom Malaysia",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "National telco.",
    "id": "acc_0064",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "U Mobile",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Growing mobile operator.",
    "id": "acc_0065",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "TIME dotCom",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Enterprise fiber/DC.",
    "id": "acc_0066",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Axiata",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Regional telco group.",
    "id": "acc_0067",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "OCK Group",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Telco infrastructure.",
    "id": "acc_0068",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Edotco",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Axiata tower company.",
    "id": "acc_0069",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "TDCX",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Regional digital CX.",
    "id": "acc_0070",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "MY E.G.",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "E-government services.",
    "id": "acc_0071",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Top Glove",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "World largest glove maker. ESG supply chain.",
    "id": "acc_0072",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Hartalega",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Glove manufacturing. ESG.",
    "id": "acc_0073",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Kossan",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Glove manufacturing.",
    "id": "acc_0074",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Sime Darby",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Auto/industrial. ESG.",
    "id": "acc_0075",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "DRB-Hicom",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Automotive/services conglomerate.",
    "id": "acc_0076",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "UMW",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Automotive/industrial.",
    "id": "acc_0077",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Inari Amertron",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Semiconductor packaging.",
    "id": "acc_0078",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Vitrox",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Semiconductor inspection.",
    "id": "acc_0079",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "MR.DIY",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Supply/manufacturing adjacent.",
    "id": "acc_0080",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Petronas Chemicals",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Industrial chemicals.",
    "id": "acc_0081",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "MOSTI",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Ministry of Science, Tech & Innovation.",
    "id": "acc_0082",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "MAMPU",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Malaysian Administrative Modernisation.",
    "id": "acc_0083",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "MIDA",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Malaysian Investment Development Authority.",
    "id": "acc_0084",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "MOF Malaysia",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Ministry of Finance.",
    "id": "acc_0085",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "MOHA Malaysia",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Ministry of Home Affairs.",
    "id": "acc_0086",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "MyDIGITAL/Unit",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Digital economy corp.",
    "id": "acc_0087",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "CyberSecurity Malaysia",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "National cybersecurity agency.",
    "id": "acc_0088",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "SPAN",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Utilities regulator.",
    "id": "acc_0089",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "PETRONAS (SOE)",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "National oil company — state enterprise.",
    "id": "acc_0090",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "PETRONAS",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "National oil & gas company.",
    "id": "acc_0091",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Sime Darby Group",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Diversified conglomerate.",
    "id": "acc_0092",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Genting",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Hospitality/entertainment group.",
    "id": "acc_0093",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Berjaya",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Diversified group.",
    "id": "acc_0094",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Sunway",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Property/construction/education.",
    "id": "acc_0095",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "YTL",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Utilities/construction/hospitality.",
    "id": "acc_0096",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Khazanah",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Sovereign wealth fund.",
    "id": "acc_0097",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "UEM Group",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Infrastructure/property.",
    "id": "acc_0098",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "IOI Group",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Palm oil/property. ESG supply chain.",
    "id": "acc_0099",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Hong Leong Group",
    "country": "Malaysia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Financial services/manufacturing.",
    "id": "acc_0100",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Bank Indonesia",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Regulator",
    "owner": "Ajay",
    "notes": "Central bank of Indonesia.",
    "id": "acc_0101",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "BCA",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Largest private bank. Strong digital.",
    "id": "acc_0102",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Bank Rakyat Indonesia (BRI)",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Largest bank by assets. Micro-banking leader.",
    "id": "acc_0103",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Bank Mandiri",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "State-owned. Largest by assets.",
    "id": "acc_0104",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "BNI",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "State bank.",
    "id": "acc_0105",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "CIMB Niaga",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "CIMB subsidiary in Indonesia.",
    "id": "acc_0106",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Danamon",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "MUFG-owned bank.",
    "id": "acc_0107",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Bank Permata",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Bangkok Bank-owned.",
    "id": "acc_0108",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Bank Syariah Indonesia (BSI)",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Largest Islamic bank in Indonesia.",
    "id": "acc_0109",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "OCBC NISP",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "OCBC subsidiary.",
    "id": "acc_0110",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Panin Bank",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Private bank.",
    "id": "acc_0111",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Telkom Indonesia",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "State telco. Largest in Indonesia.",
    "id": "acc_0112",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Telkomsel",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Largest mobile operator.",
    "id": "acc_0113",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Indosat Ooredoo Hutchison",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Merged telco.",
    "id": "acc_0114",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "XL Axiata",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Axiata subsidiary.",
    "id": "acc_0115",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Smartfren",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Sinar Mas-backed telco.",
    "id": "acc_0116",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Biznet",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "ISP/DC provider.",
    "id": "acc_0117",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "MNC Vision Networks",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Media/broadband.",
    "id": "acc_0118",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Mitratel",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Telkom tower subsidiary.",
    "id": "acc_0119",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Tower Bersama",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Tower infrastructure.",
    "id": "acc_0120",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "DCI Indonesia",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Data center.",
    "id": "acc_0121",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Astra International",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Largest conglomerate. Auto/mining/agri.",
    "id": "acc_0122",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Indofood",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Largest food company. Supply chain.",
    "id": "acc_0123",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Unilever Indonesia",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "FMCG manufacturing.",
    "id": "acc_0124",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Chandra Asri",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Petrochemicals.",
    "id": "acc_0125",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Krakatau Steel",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "State steel company.",
    "id": "acc_0126",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Semen Indonesia",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "State cement company.",
    "id": "acc_0127",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Pupuk Indonesia",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "State fertilizer.",
    "id": "acc_0128",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Vale Indonesia",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Nickel mining.",
    "id": "acc_0129",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Freeport Indonesia",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Copper/gold mining.",
    "id": "acc_0130",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Panasonic Gobel",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Electronics manufacturing.",
    "id": "acc_0131",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "OJK",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Financial Services Authority.",
    "id": "acc_0132",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Kominfo",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Ministry of Communication & IT.",
    "id": "acc_0133",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Ministry of Finance ID",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "",
    "id": "acc_0134",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "BKPM/Investment Ministry",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Investment coordination.",
    "id": "acc_0135",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "BSSN",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "National cybersecurity agency.",
    "id": "acc_0136",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "PLN (SOE)",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "State electricity company.",
    "id": "acc_0137",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Pertamina (SOE)",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "State oil & gas.",
    "id": "acc_0138",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "LKPP",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Government procurement.",
    "id": "acc_0139",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "BPJS",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Social security administration.",
    "id": "acc_0140",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Salim Group (Indofood)",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Major conglomerate — food, cement, retail.",
    "id": "acc_0141",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Sinar Mas",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Paper/palm oil/financial services. ESG.",
    "id": "acc_0142",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Lippo",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Property/healthcare/education.",
    "id": "acc_0143",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Mayapada",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Banking/property group.",
    "id": "acc_0144",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "CT Corp",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Media/retail/financial group.",
    "id": "acc_0145",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "MNC Group",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Media/financial services.",
    "id": "acc_0146",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Barito Pacific",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Petrochemicals/geothermal.",
    "id": "acc_0147",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Bakrie",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Diversified group.",
    "id": "acc_0148",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Djarum",
    "country": "Indonesia",
    "region": "APAC",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Tobacco/BCA stakeholder.",
    "id": "acc_0149",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Reserve Bank of India (RBI)",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Regulator",
    "owner": "Ajay",
    "notes": "Central bank of India.",
    "id": "acc_0150",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "SBI",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Partha",
    "notes": "State Bank of India — largest bank.",
    "id": "acc_0151",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "HDFC Bank",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Partha",
    "notes": "Largest private sector bank.",
    "id": "acc_0152",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "ICICI Bank",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Partha",
    "notes": "Major private bank.",
    "id": "acc_0153",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Axis Bank",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Partha",
    "notes": "",
    "id": "acc_0154",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Kotak Mahindra Bank",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Partha",
    "notes": "",
    "id": "acc_0155",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "IndusInd Bank",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Partha",
    "notes": "",
    "id": "acc_0156",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Bank of Baroda",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Partha",
    "notes": "State bank.",
    "id": "acc_0157",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "PNB",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Partha",
    "notes": "Punjab National Bank.",
    "id": "acc_0158",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Canara Bank",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Partha",
    "notes": "",
    "id": "acc_0159",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Union Bank of India",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Partha",
    "notes": "",
    "id": "acc_0160",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Reliance Jio",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Partha",
    "notes": "Largest telco.",
    "id": "acc_0161",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Bharti Airtel",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Partha",
    "notes": "Major telco.",
    "id": "acc_0162",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Vodafone Idea",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Partha",
    "notes": "",
    "id": "acc_0163",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Tata Communications",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Partha",
    "notes": "Enterprise connectivity.",
    "id": "acc_0164",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "BSNL",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Partha",
    "notes": "State telco.",
    "id": "acc_0165",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "RailTel",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Partha",
    "notes": "Railway telecom/broadband.",
    "id": "acc_0166",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Tejas Networks",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Partha",
    "notes": "Tata-owned optical networking.",
    "id": "acc_0167",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "HFCL",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Partha",
    "notes": "Telecom equipment.",
    "id": "acc_0168",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Sterlite Technologies",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Partha",
    "notes": "Fiber optic cables.",
    "id": "acc_0169",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Indus Towers",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Partha",
    "notes": "Tower infrastructure.",
    "id": "acc_0170",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Tata Motors",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Partha",
    "notes": "Major auto. Active ContexQ prospect.",
    "id": "acc_0171",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Mahindra & Mahindra",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Partha",
    "notes": "Auto/farm equipment.",
    "id": "acc_0172",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Maruti Suzuki",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Partha",
    "notes": "Largest car maker.",
    "id": "acc_0173",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Bajaj Auto",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Partha",
    "notes": "Two-wheeler/three-wheeler.",
    "id": "acc_0174",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "TVS Motor",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Partha",
    "notes": "Two-wheeler manufacturer.",
    "id": "acc_0175",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Larsen & Toubro",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Partha",
    "notes": "Engineering/construction giant.",
    "id": "acc_0176",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Bharat Forge",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Partha",
    "notes": "Forging/auto components.",
    "id": "acc_0177",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Siemens India",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Partha",
    "notes": "Industrial conglomerate.",
    "id": "acc_0178",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Sun Pharma",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Partha",
    "notes": "Largest pharma company.",
    "id": "acc_0179",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Dr Reddy's",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Partha",
    "notes": "Major pharma.",
    "id": "acc_0180",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "MeitY",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Partha",
    "notes": "Ministry of Electronics & IT.",
    "id": "acc_0181",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "UIDAI",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Partha",
    "notes": "Aadhaar authority.",
    "id": "acc_0182",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "NPCI",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Partha",
    "notes": "National Payments Corporation (UPI).",
    "id": "acc_0183",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "NITI Aayog",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Partha",
    "notes": "Policy think tank.",
    "id": "acc_0184",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Ministry of Finance India",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Partha",
    "notes": "",
    "id": "acc_0185",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "GSTN",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Partha",
    "notes": "GST Network — tax infrastructure.",
    "id": "acc_0186",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "CBI",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Partha",
    "notes": "Central Bureau of Investigation.",
    "id": "acc_0187",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "ED (Enforcement Directorate)",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Partha",
    "notes": "Financial crime enforcement.",
    "id": "acc_0188",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "SEBI",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Partha",
    "notes": "Securities regulator.",
    "id": "acc_0189",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "IRDAI",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Partha",
    "notes": "Insurance regulator.",
    "id": "acc_0190",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Tata Group",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Partha",
    "notes": "Largest Indian conglomerate. Multi-sector.",
    "id": "acc_0191",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Reliance Industries",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Partha",
    "notes": "Largest company by market cap.",
    "id": "acc_0192",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Adani Group",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Partha",
    "notes": "Infrastructure/energy/ports. ESG relevance.",
    "id": "acc_0193",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Mahindra Group",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Partha",
    "notes": "Auto/IT/financial services.",
    "id": "acc_0194",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Birla Group",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Partha",
    "notes": "Diversified — cement, metals, telecom.",
    "id": "acc_0195",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "L&T Group",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Partha",
    "notes": "Engineering/construction.",
    "id": "acc_0196",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Bajaj Group",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Partha",
    "notes": "Auto/financial services.",
    "id": "acc_0197",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Godrej",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Partha",
    "notes": "FMCG/property/agri.",
    "id": "acc_0198",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Vedanta",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Partha",
    "notes": "Mining/metals. ESG.",
    "id": "acc_0199",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Bharti Enterprises",
    "country": "India",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Partha",
    "notes": "Telecom/hospitality.",
    "id": "acc_0200",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Bank of Thailand",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Regulator",
    "owner": "Ajay",
    "notes": "Central bank of Thailand.",
    "id": "acc_0201",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Bangkok Bank",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Largest commercial bank.",
    "id": "acc_0202",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Kasikornbank",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "KBank — strong digital banking.",
    "id": "acc_0203",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Krungthai Bank",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "State-owned bank.",
    "id": "acc_0204",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Siam Commercial Bank (SCB X)",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Rebranded as SCB X — tech-focused.",
    "id": "acc_0205",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Bank of Ayudhya (Krungsri)",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "MUFG subsidiary.",
    "id": "acc_0206",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "TTB",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "TMBThanachart Bank.",
    "id": "acc_0207",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Government Savings Bank",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "State savings bank.",
    "id": "acc_0208",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "CIMB Thai",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "",
    "id": "acc_0209",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "UOB Thailand",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "UOB subsidiary after Citi acquisition.",
    "id": "acc_0210",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "LH Bank",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Land & Houses Bank.",
    "id": "acc_0211",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "AIS",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Largest mobile operator.",
    "id": "acc_0212",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "True Corporation",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Merged True+dtac.",
    "id": "acc_0213",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Jasmine (JAS)",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Broadband/infrastructure.",
    "id": "acc_0214",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "NT (National Telecom)",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "State telco (merged TOT+CAT).",
    "id": "acc_0215",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Thaicom",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Satellite operator.",
    "id": "acc_0216",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "InTouch",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Telecom holding.",
    "id": "acc_0217",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Gulf Edge",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Data/cables infrastructure.",
    "id": "acc_0218",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "PTT",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "State oil & gas. Largest Thai company.",
    "id": "acc_0219",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Thai Oil",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "PTT subsidiary — refining.",
    "id": "acc_0220",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "SCG (Siam Cement Group)",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Largest industrial conglomerate.",
    "id": "acc_0221",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Toyota Thailand",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Major auto manufacturing.",
    "id": "acc_0222",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Honda Thailand",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Auto manufacturing.",
    "id": "acc_0223",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Western Digital Thailand",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "HDD manufacturing.",
    "id": "acc_0224",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Delta Electronics Thailand",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Power/electronics manufacturing.",
    "id": "acc_0225",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "DEPA Thailand",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Digital Economy Promotion Agency.",
    "id": "acc_0226",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "ETDA",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Electronic Transactions Development Agency.",
    "id": "acc_0227",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "SEC Thailand",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Securities and Exchange Commission.",
    "id": "acc_0228",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Royal Thai Police",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Fraud/crime investigation.",
    "id": "acc_0229",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Ministry of Digital Economy TH",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "",
    "id": "acc_0230",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "AMLO Thailand",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Anti-Money Laundering Office.",
    "id": "acc_0231",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Ministry of Finance TH",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "",
    "id": "acc_0232",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Customs Thailand",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Thai Customs Department.",
    "id": "acc_0233",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "DBD Thailand",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Dept of Business Development — business registry.",
    "id": "acc_0234",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "CP Group",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Charoen Pokphand — agri/retail/telecom. Largest Thai conglomerate.",
    "id": "acc_0235",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "PTT Group",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "State energy conglomerate.",
    "id": "acc_0236",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Central Group",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Retail/hospitality.",
    "id": "acc_0237",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "ThaiBev/TCC",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Beverages/property — TCC Group.",
    "id": "acc_0238",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Bangkok Dusit (BDMS)",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Healthcare group.",
    "id": "acc_0239",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Minor International",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Hospitality/food.",
    "id": "acc_0240",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "B.Grimm",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Energy/healthcare.",
    "id": "acc_0241",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Gulf Energy",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Power generation.",
    "id": "acc_0242",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Muang Thai Group",
    "country": "Thailand",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Insurance/financial services group.",
    "id": "acc_0243",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "State Bank of Vietnam",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Regulator",
    "owner": "Ajay",
    "notes": "Central bank of Vietnam.",
    "id": "acc_0244",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Vietcombank",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Largest bank by market cap.",
    "id": "acc_0245",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "BIDV",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "State-owned. Largest by assets.",
    "id": "acc_0246",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "VietinBank",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "State-owned bank.",
    "id": "acc_0247",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Agribank",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Agricultural bank.",
    "id": "acc_0248",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "MB (Military Bank)",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Strong digital bank.",
    "id": "acc_0249",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Techcombank",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Leading private bank.",
    "id": "acc_0250",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "ACB",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Asia Commercial Bank.",
    "id": "acc_0251",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "VPBank",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "",
    "id": "acc_0252",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Sacombank",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "",
    "id": "acc_0253",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "SHB",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Saigon-Hanoi Bank.",
    "id": "acc_0254",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Viettel",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Military-owned telco — largest in Vietnam. Expanding Africa/LATAM.",
    "id": "acc_0255",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "VNPT",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "State telco.",
    "id": "acc_0256",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "MobiFone",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "State mobile operator.",
    "id": "acc_0257",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "FPT Telecom",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "FPT subsidiary.",
    "id": "acc_0258",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "CMC Telecom",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "CMC Corp telco arm.",
    "id": "acc_0259",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Vietnamobile",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Mobile operator.",
    "id": "acc_0260",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "SCTV",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Cable TV/broadband.",
    "id": "acc_0261",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "VNG",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Tech platform/gaming.",
    "id": "acc_0262",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "FPT Software",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "IT services — largest VN tech company.",
    "id": "acc_0263",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Vingroup/VinFast",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Largest private group. EV manufacturing.",
    "id": "acc_0264",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Hoa Phat",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Largest steel producer.",
    "id": "acc_0265",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Masan",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "FMCG/retail/resources.",
    "id": "acc_0266",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Samsung Vietnam",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Largest FDI employer — electronics.",
    "id": "acc_0267",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Intel Vietnam",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Chip assembly/testing.",
    "id": "acc_0268",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Foxconn Vietnam",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Electronics manufacturing.",
    "id": "acc_0269",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "LG Vietnam",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Electronics manufacturing.",
    "id": "acc_0270",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "THACO",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Auto manufacturing/assembly.",
    "id": "acc_0271",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "PetroVietnam",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "State oil & gas.",
    "id": "acc_0272",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Vietnam Airlines",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "State-linked airline ecosystem.",
    "id": "acc_0273",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Ministry of Public Security VN",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Fraud/crime investigation.",
    "id": "acc_0274",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "MIC Vietnam",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Ministry of Information & Communications.",
    "id": "acc_0275",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "MPI Vietnam",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Ministry of Planning & Investment.",
    "id": "acc_0276",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "State Securities Commission VN",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Securities regulator.",
    "id": "acc_0277",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Tax General Department VN",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Tax authority.",
    "id": "acc_0278",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Vietnam Customs",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Customs authority.",
    "id": "acc_0279",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "EVN",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Electricity of Vietnam — state enterprise.",
    "id": "acc_0280",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "National Data Center VN",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "National data center initiatives.",
    "id": "acc_0281",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Vingroup",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Real estate/tech/manufacturing.",
    "id": "acc_0282",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Masan Group",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "FMCG/mining/retail.",
    "id": "acc_0283",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Sovico",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Aviation/real estate/finance.",
    "id": "acc_0284",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Viettel Group",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Military telco group.",
    "id": "acc_0285",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "FPT Group",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Tech/IT services.",
    "id": "acc_0286",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Gelex",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Electrical/water/real estate.",
    "id": "acc_0287",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Hoa Phat Group",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Steel/real estate/agriculture.",
    "id": "acc_0288",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "THACO Group",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Auto/agriculture/logistics.",
    "id": "acc_0289",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "PetroVietnam Group",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "National oil & gas group.",
    "id": "acc_0290",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "VNPT Group",
    "country": "Vietnam",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "State telecom group.",
    "id": "acc_0291",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Bangko Sentral ng Pilipinas (BSP)",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Regulator",
    "owner": "Ajay",
    "notes": "Central bank of the Philippines.",
    "id": "acc_0292",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "BDO",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Largest bank.",
    "id": "acc_0293",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "LandBank",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Government bank.",
    "id": "acc_0294",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "BPI",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Bank of the Philippine Islands.",
    "id": "acc_0295",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Metrobank",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Major private bank.",
    "id": "acc_0296",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "China Bank",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "",
    "id": "acc_0297",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "RCBC",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Yuchengco Group bank.",
    "id": "acc_0298",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Security Bank",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "",
    "id": "acc_0299",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "PNB Philippines",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Philippine National Bank.",
    "id": "acc_0300",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "DBP",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Development Bank of the Philippines.",
    "id": "acc_0301",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "UnionBank",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Gilbert",
    "notes": "Digital banking leader.",
    "id": "acc_0302",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "PLDT/Smart",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Largest telco group.",
    "id": "acc_0303",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Globe",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Ayala-linked telco.",
    "id": "acc_0304",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "DITO Telecommunity",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Third telco. Dennis Uy / China Telecom.",
    "id": "acc_0305",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Converge ICT",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Fiber broadband.",
    "id": "acc_0306",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "SkyCable",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Cable/broadband.",
    "id": "acc_0307",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "NOW Corp",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Telecom/IT.",
    "id": "acc_0308",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Radius Telecoms",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Fiber/enterprise connectivity.",
    "id": "acc_0309",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "DFNN",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Nick",
    "notes": "Digital/tech platform.",
    "id": "acc_0310",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "San Miguel",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Largest conglomerate — food/beverages/infrastructure.",
    "id": "acc_0311",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Ayala Manufacturing",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Ayala Group manufacturing assets.",
    "id": "acc_0312",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "JG Summit (URC)",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Gokongwei group — food/petrochem.",
    "id": "acc_0313",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Century Pacific",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Food manufacturing.",
    "id": "acc_0314",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "DMCI",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Construction/mining/real estate.",
    "id": "acc_0315",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Megawide",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Construction/infrastructure.",
    "id": "acc_0316",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "First Gen",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Power generation — Lopez Group.",
    "id": "acc_0317",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Phoenix Petroleum",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Manufacturing",
    "owner": "Nick",
    "notes": "Fuel/petroleum.",
    "id": "acc_0318",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "AMLC Philippines",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Anti-Money Laundering Council.",
    "id": "acc_0319",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "DICT",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Dept of Information & Communications Technology.",
    "id": "acc_0320",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "DOF Philippines",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Department of Finance.",
    "id": "acc_0321",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "BIR Philippines",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Bureau of Internal Revenue.",
    "id": "acc_0322",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Philippines Customs",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Bureau of Customs.",
    "id": "acc_0323",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "PhilSys/PSA",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "National ID system / Statistics Authority.",
    "id": "acc_0324",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "SEC Philippines",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "Securities & Exchange Commission.",
    "id": "acc_0325",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "NPC Philippines",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "National Power Corporation.",
    "id": "acc_0326",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "NEDA",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Government",
    "owner": "Nick",
    "notes": "National Economic & Development Authority.",
    "id": "acc_0327",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Ayala",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Oldest conglomerate — banking/real estate/telco.",
    "id": "acc_0328",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "SM Group",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Retail/banking/real estate.",
    "id": "acc_0329",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "JG Summit Group",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Gokongwei group.",
    "id": "acc_0330",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Aboitiz",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Power/banking/food.",
    "id": "acc_0331",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Lopez Group",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Energy/media/infrastructure.",
    "id": "acc_0332",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Metro Pacific",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Infrastructure/utilities.",
    "id": "acc_0333",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "LT Group",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Lucio Tan group — banking/tobacco/airlines.",
    "id": "acc_0334",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "DMCI Group",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "Construction/mining.",
    "id": "acc_0335",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Gokongwei Group",
    "country": "Philippines",
    "region": "APAC",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Nick",
    "notes": "JG Summit parent.",
    "id": "acc_0336",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Saudi Central Bank (SAMA)",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Regulator",
    "owner": "Ajay",
    "notes": "Saudi Arabian Monetary Authority.",
    "id": "acc_0337",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Saudi National Bank",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "Largest bank in Saudi Arabia.",
    "id": "acc_0338",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Al Rajhi Bank",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "Largest Islamic bank globally.",
    "id": "acc_0339",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Riyad Bank",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "Major Saudi bank.",
    "id": "acc_0340",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Banque Saudi Fransi",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "",
    "id": "acc_0341",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Arab National Bank",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "",
    "id": "acc_0342",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Alinma Bank",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "Islamic bank.",
    "id": "acc_0343",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Bank AlJazira",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "",
    "id": "acc_0344",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Bank Albilad",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "",
    "id": "acc_0345",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Saudi Awwal Bank (SABB)",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "HSBC subsidiary.",
    "id": "acc_0346",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Gulf International Bank (KSA)",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "",
    "id": "acc_0347",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "stc",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "Saudi Telecom Company — largest operator.",
    "id": "acc_0348",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Mobily",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "Etihad Etisalat.",
    "id": "acc_0349",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Zain KSA",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "",
    "id": "acc_0350",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Salam",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "",
    "id": "acc_0351",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "NourNet",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "Enterprise connectivity/MPLS.",
    "id": "acc_0352",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Sahara Net",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "ISP.",
    "id": "acc_0353",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "solutions by stc",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "stc IT services arm.",
    "id": "acc_0354",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "NEOM tech vendors",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "NEOM mega-project tech ecosystem.",
    "id": "acc_0355",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Arab Satellite (Arabsat)",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "Regional satellite operator.",
    "id": "acc_0356",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "GOSI",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "General Organization for Social Insurance — tech adjacency.",
    "id": "acc_0357",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Saudi Aramco",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Attif",
    "notes": "World largest oil company. ESG relevance.",
    "id": "acc_0358",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "SABIC",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Attif",
    "notes": "Major petrochemicals.",
    "id": "acc_0359",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Ma'aden",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Attif",
    "notes": "Saudi mining company.",
    "id": "acc_0360",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "ACWA Power",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Attif",
    "notes": "Power/water/green energy.",
    "id": "acc_0361",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Saudi Electricity Co",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Attif",
    "notes": "National electricity provider.",
    "id": "acc_0362",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "SADARA",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Attif",
    "notes": "Aramco/Dow JV — chemicals.",
    "id": "acc_0363",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "SPIMACO",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Attif",
    "notes": "Saudi pharmaceutical.",
    "id": "acc_0364",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Tasnee",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Attif",
    "notes": "National industrialization.",
    "id": "acc_0365",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Advanced Petrochemical",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Attif",
    "notes": "Polypropylene production.",
    "id": "acc_0366",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Sipchem",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Attif",
    "notes": "Petrochemicals.",
    "id": "acc_0367",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Ministry of Interior KSA",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Attif",
    "notes": "",
    "id": "acc_0368",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Ministry of Finance KSA",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Attif",
    "notes": "",
    "id": "acc_0369",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "SDAIA",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Attif",
    "notes": "Saudi Data & AI Authority.",
    "id": "acc_0370",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "NCA (Cyber)",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Attif",
    "notes": "National Cybersecurity Authority.",
    "id": "acc_0371",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "ZATCA",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Attif",
    "notes": "Tax & Customs Authority.",
    "id": "acc_0372",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Monsha'at",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Attif",
    "notes": "SME Authority.",
    "id": "acc_0373",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "MISA",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Attif",
    "notes": "Ministry of Investment.",
    "id": "acc_0374",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "NUPCO",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Attif",
    "notes": "National Unified Procurement Company.",
    "id": "acc_0375",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "CMA Saudi",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Attif",
    "notes": "Capital Market Authority (SEC equivalent).",
    "id": "acc_0376",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "PIF",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Public Investment Fund — $930B+ AUM. Vision 2030 engine.",
    "id": "acc_0377",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Al Rajhi Group",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Diversified Islamic business group.",
    "id": "acc_0378",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Olayan",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Major diversified group.",
    "id": "acc_0379",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Savola",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Food/retail.",
    "id": "acc_0380",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Abdul Latif Jameel",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Automotive/financial services/energy.",
    "id": "acc_0381",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Kingdom Holding",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Prince Alwaleed — diversified investments.",
    "id": "acc_0382",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Zahid Group",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Industrial/services diversified.",
    "id": "acc_0383",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Almarai",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Largest dairy/food company in ME.",
    "id": "acc_0384",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "STC Group",
    "country": "Saudi Arabia",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Telecom group — expanding into digital.",
    "id": "acc_0385",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Central Bank of the UAE",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Regulator",
    "owner": "Ajay",
    "notes": "CBUAE.",
    "id": "acc_0386",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "First Abu Dhabi Bank (FAB)",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "Largest bank in UAE.",
    "id": "acc_0387",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Emirates NBD",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "Major Dubai-based bank.",
    "id": "acc_0388",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Abu Dhabi Commercial Bank (ADCB)",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "",
    "id": "acc_0389",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Dubai Islamic Bank",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "Largest Islamic bank in UAE.",
    "id": "acc_0390",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Mashreq",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "Digital banking leader.",
    "id": "acc_0391",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "RAKBANK",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "Ras Al Khaimah bank.",
    "id": "acc_0392",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Emirates Islamic",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "Emirates NBD subsidiary.",
    "id": "acc_0393",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "ADIB",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "Abu Dhabi Islamic Bank.",
    "id": "acc_0394",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Sharjah Islamic Bank",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "",
    "id": "acc_0395",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Commercial Bank of Dubai",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "",
    "id": "acc_0396",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "e&",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "Etisalat rebranded. Major telco.",
    "id": "acc_0397",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "du",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "EITC — second telco.",
    "id": "acc_0398",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Etisalat Digital",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "e& digital services arm.",
    "id": "acc_0399",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Injazat/G42 ecosystem",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "AI/cloud ecosystem.",
    "id": "acc_0400",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Khazna DC",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "Data center.",
    "id": "acc_0401",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Moro Hub",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "DEWA digital arm.",
    "id": "acc_0402",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Yahsat",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "Satellite communications.",
    "id": "acc_0403",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Thuraya",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "Satellite communications.",
    "id": "acc_0404",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Emirates Integrated",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "Telecom infrastructure.",
    "id": "acc_0405",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Space42",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "Newco — AI/space/data.",
    "id": "acc_0406",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "ADNOC",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Attif",
    "notes": "Abu Dhabi National Oil. Largest company.",
    "id": "acc_0407",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Borouge",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Attif",
    "notes": "ADNOC/Borealis plastics JV.",
    "id": "acc_0408",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Emirates Global Aluminium (EGA)",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Attif",
    "notes": "Largest industrial company outside oil.",
    "id": "acc_0409",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "DP World",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Attif",
    "notes": "Global ports/logistics. Supply chain.",
    "id": "acc_0410",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "EDGE Group",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Attif",
    "notes": "Defense/technology.",
    "id": "acc_0411",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Emirates Steel Arkan",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Attif",
    "notes": "Steel/building materials.",
    "id": "acc_0412",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "TAQA",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Attif",
    "notes": "Abu Dhabi National Energy.",
    "id": "acc_0413",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Strata",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Attif",
    "notes": "Aerospace composites manufacturing.",
    "id": "acc_0414",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Al Dahra",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Manufacturing",
    "owner": "Attif",
    "notes": "Agriculture/animal feed. ESG supply chain.",
    "id": "acc_0415",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Digital Dubai",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Attif",
    "notes": "Dubai digital transformation authority.",
    "id": "acc_0416",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Dubai Police",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Attif",
    "notes": "Fraud/crime investigation.",
    "id": "acc_0417",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "ADDA",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Attif",
    "notes": "Abu Dhabi Digital Authority.",
    "id": "acc_0418",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "TDRA",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Attif",
    "notes": "Telecommunications & Digital Govt Regulatory Authority.",
    "id": "acc_0419",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "MOF UAE",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Attif",
    "notes": "Ministry of Finance.",
    "id": "acc_0420",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "UAE Cybersecurity Council",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Attif",
    "notes": "National cybersecurity.",
    "id": "acc_0421",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "ADGM",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Attif",
    "notes": "Abu Dhabi Global Market — financial free zone.",
    "id": "acc_0422",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "DIFC",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Attif",
    "notes": "Dubai International Financial Centre.",
    "id": "acc_0423",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Dubai Customs",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Government",
    "owner": "Attif",
    "notes": "Trade/customs authority.",
    "id": "acc_0424",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Mubadala",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Sovereign wealth fund — $300B+ AUM.",
    "id": "acc_0425",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "ADQ",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Abu Dhabi holding company.",
    "id": "acc_0426",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Investment Corporation of Dubai (ICD)",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Dubai sovereign investment.",
    "id": "acc_0427",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Majid Al Futtaim",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Retail/entertainment.",
    "id": "acc_0428",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Al-Futtaim",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Automotive/retail/real estate.",
    "id": "acc_0429",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Emirates Group",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Aviation/dnata.",
    "id": "acc_0430",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Emaar",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Real estate developer.",
    "id": "acc_0431",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "DAMAC",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Real estate/data centers.",
    "id": "acc_0432",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Aldar",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Real estate/development.",
    "id": "acc_0433",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "G42",
    "country": "UAE",
    "region": "Middle East",
    "priority": "Strategic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "AI/cloud — major tech ecosystem. Microsoft partnership.",
    "id": "acc_0434",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Banque de France / ACPR",
    "country": "France",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Regulator",
    "owner": "Ajay",
    "notes": "French central bank / prudential authority.",
    "id": "acc_0435",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "BNP Paribas",
    "country": "France",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "Largest EU bank.",
    "id": "acc_0436",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Crédit Agricole",
    "country": "France",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "Cooperative banking group.",
    "id": "acc_0437",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Société Générale",
    "country": "France",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "",
    "id": "acc_0438",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "BPCE/Natixis",
    "country": "France",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "Cooperative group.",
    "id": "acc_0439",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Crédit Mutuel",
    "country": "France",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "",
    "id": "acc_0440",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Orange",
    "country": "France",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "Major French telco.",
    "id": "acc_0441",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Iliad/Free",
    "country": "France",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "Disruptive telco.",
    "id": "acc_0442",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "SFR/Altice",
    "country": "France",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "",
    "id": "acc_0443",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "TotalEnergies",
    "country": "France",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Major energy company. ESG.",
    "id": "acc_0444",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Airbus",
    "country": "France",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Aerospace/defense. Supply chain complexity.",
    "id": "acc_0445",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Thales",
    "country": "France",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Defense/digital security.",
    "id": "acc_0446",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Schneider Electric",
    "country": "France",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Energy management/automation.",
    "id": "acc_0447",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Sanofi",
    "country": "France",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Pharma. Supply chain.",
    "id": "acc_0448",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Safran",
    "country": "France",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Aerospace/defense.",
    "id": "acc_0449",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Bundesbank / BaFin",
    "country": "Germany",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Regulator",
    "owner": "Ajay",
    "notes": "German central bank / financial regulator.",
    "id": "acc_0450",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Deutsche Bank",
    "country": "Germany",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "Largest German bank. Gilbert connection via Danske.",
    "id": "acc_0451",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Commerzbank",
    "country": "Germany",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "",
    "id": "acc_0452",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "DZ Bank",
    "country": "Germany",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "Cooperative central bank.",
    "id": "acc_0453",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "KfW",
    "country": "Germany",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "State development bank.",
    "id": "acc_0454",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "UniCredit HVB",
    "country": "Germany",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "UniCredit Germany arm.",
    "id": "acc_0455",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Deutsche Telekom",
    "country": "Germany",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "Largest European telco.",
    "id": "acc_0456",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Vodafone DE",
    "country": "Germany",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "",
    "id": "acc_0457",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Telefónica DE",
    "country": "Germany",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "O2 Germany.",
    "id": "acc_0458",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Siemens",
    "country": "Germany",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Industrial giant. Supply chain.",
    "id": "acc_0459",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Volkswagen Group",
    "country": "Germany",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Largest auto group. ESG supply chain.",
    "id": "acc_0460",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "BMW",
    "country": "Germany",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "",
    "id": "acc_0461",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Mercedes-Benz Group",
    "country": "Germany",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "",
    "id": "acc_0462",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "SAP",
    "country": "Germany",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Enterprise software giant. Integration partner potential.",
    "id": "acc_0463",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Bosch",
    "country": "Germany",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Industrial/auto technology. Largest private company.",
    "id": "acc_0464",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Banca d'Italia",
    "country": "Italy",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Regulator",
    "owner": "Ajay",
    "notes": "Italian central bank.",
    "id": "acc_0465",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Intesa Sanpaolo",
    "country": "Italy",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "Largest Italian bank.",
    "id": "acc_0466",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "UniCredit",
    "country": "Italy",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "Major pan-European bank.",
    "id": "acc_0467",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Banco BPM",
    "country": "Italy",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "",
    "id": "acc_0468",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Monte dei Paschi",
    "country": "Italy",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "Oldest bank in the world.",
    "id": "acc_0469",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "BPER",
    "country": "Italy",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "Banca Popolare Emilia Romagna.",
    "id": "acc_0470",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "TIM",
    "country": "Italy",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "Italian national telco.",
    "id": "acc_0471",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Vodafone IT",
    "country": "Italy",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "Vodafone Italy.",
    "id": "acc_0472",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Fastweb",
    "country": "Italy",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "Broadband/fiber.",
    "id": "acc_0473",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "ENI",
    "country": "Italy",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Major oil & gas. ESG relevance.",
    "id": "acc_0474",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Enel",
    "country": "Italy",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Largest utility in Europe.",
    "id": "acc_0475",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Leonardo",
    "country": "Italy",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Defense/aerospace.",
    "id": "acc_0476",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Stellantis",
    "country": "Italy",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Automotive (Italy-linked). Fiat/Peugeot/Chrysler.",
    "id": "acc_0477",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Pirelli",
    "country": "Italy",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Tires/industrial.",
    "id": "acc_0478",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Danmarks Nationalbank",
    "country": "Denmark",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Regulator",
    "owner": "Ajay",
    "notes": "Danish central bank.",
    "id": "acc_0479",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Danske Bank",
    "country": "Denmark",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "Largest Danish bank. Gilbert ex-CRO. AML history — high relevance.",
    "id": "acc_0480",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Nykredit",
    "country": "Denmark",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "Largest mortgage provider.",
    "id": "acc_0481",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Jyske Bank",
    "country": "Denmark",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "",
    "id": "acc_0482",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Nordea DK",
    "country": "Denmark",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Banking",
    "owner": "Attif",
    "notes": "Nordic bank DK operations.",
    "id": "acc_0483",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "TDC Net",
    "country": "Denmark",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "Danish telecom infrastructure.",
    "id": "acc_0484",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Telia DK",
    "country": "Denmark",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "Nordic telco DK operations.",
    "id": "acc_0485",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Telenor DK",
    "country": "Denmark",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Telecom",
    "owner": "Attif",
    "notes": "Nordic telco DK operations.",
    "id": "acc_0486",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Maersk",
    "country": "Denmark",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Largest shipping company. Supply chain intelligence goldmine.",
    "id": "acc_0487",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Novo Nordisk",
    "country": "Denmark",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Most valuable EU company. Pharma supply chain.",
    "id": "acc_0488",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Vestas",
    "country": "Denmark",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Wind energy. ESG.",
    "id": "acc_0489",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Ørsted",
    "country": "Denmark",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Renewable energy. ESG.",
    "id": "acc_0490",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  },
  {
    "name": "Carlsberg",
    "country": "Denmark",
    "region": "EU",
    "priority": "Opportunistic",
    "sector": "Conglomerate",
    "owner": "Attif",
    "notes": "Global brewer. Supply chain.",
    "id": "acc_0491",
    "useCases": [],
    "keyPeople": [],
    "competitors": [],
    "warmContacts": [],
    "status": "prospect",
    "priority_rank": ""
  }
];

export default GTM_ACCOUNTS;
